import { render, staticRenderFns } from "./AdminStatMenu.vue?vue&type=template&id=32069b9a&scoped=true&"
import script from "./AdminStatMenu.vue?vue&type=script&lang=js&"
export * from "./AdminStatMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatMenu.vue?vue&type=style&index=0&id=32069b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32069b9a",
  null
  
)

export default component.exports